const TOKEN_KEY = 'immediateLoadingAdminToken'
const EXPIRES_AT_KEY = 'immediateLoadingAdminExpiresAt'
const ADMIN_KEY = 'immediateLoadingAdmin'
const SYNC_CHANNEL_NAME = 'immediate-loading-admin-auth'
const SYNC_EVENT_NAME = 'immediate-loading-admin-session-synced'
const AUTH_EXPIRED_EVENT_NAME = 'immediate-loading-admin-auth-expired'

let syncChannel = null

function isCompleteAuth (auth) {
  return Boolean(auth && auth.token && auth.expiresAtEpochMs && auth.admin)
}

function storedAuth () {
  const token = sessionStorage.getItem(TOKEN_KEY) || ''
  const expiresAtEpochMs = Number(sessionStorage.getItem(EXPIRES_AT_KEY) || 0)
  const adminValue = sessionStorage.getItem(ADMIN_KEY)
  if (!token || !expiresAtEpochMs || !adminValue) {
    return null
  }
  try {
    return {
      token,
      expiresAtEpochMs,
      admin: JSON.parse(adminValue)
    }
  } catch (error) {
    clearStoredAuth()
    return null
  }
}

function writeStoredAuth (auth) {
  sessionStorage.setItem(TOKEN_KEY, auth.token)
  sessionStorage.setItem(EXPIRES_AT_KEY, String(auth.expiresAtEpochMs))
  sessionStorage.setItem(ADMIN_KEY, JSON.stringify(auth.admin))
}

function clearStoredAuth () {
  sessionStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(EXPIRES_AT_KEY)
  sessionStorage.removeItem(ADMIN_KEY)
}

function dispatchWindowEvent (name) {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent(name))
  }
}

if (typeof BroadcastChannel !== 'undefined') {
  try {
    syncChannel = new BroadcastChannel(SYNC_CHANNEL_NAME)
    syncChannel.onmessage = event => {
      const message = event && event.data
      if (!message || !message.type) {
        return
      }
      if (message.type === 'REQUEST') {
        const auth = storedAuth()
        if (isCompleteAuth(auth) && auth.expiresAtEpochMs > Date.now() + 5000) {
          syncChannel.postMessage({ type: 'SESSION', auth })
        }
        return
      }
      if (message.type === 'SESSION' && isCompleteAuth(message.auth) &&
          Number(message.auth.expiresAtEpochMs) > Date.now() + 5000) {
        writeStoredAuth(message.auth)
        dispatchWindowEvent(SYNC_EVENT_NAME)
        return
      }
      if (message.type === 'CLEAR') {
        clearStoredAuth()
        dispatchWindowEvent(AUTH_EXPIRED_EVENT_NAME)
      }
    }
  } catch (error) {
    syncChannel = null
  }
}

export function saveImmediateLoadingAdminSession (auth) {
  if (!isCompleteAuth(auth)) {
    throw new Error('管理员登录响应不完整')
  }
  writeStoredAuth(auth)
  if (syncChannel) {
    syncChannel.postMessage({ type: 'SESSION', auth })
  }
}

export function clearImmediateLoadingAdminSession (broadcast = true) {
  clearStoredAuth()
  if (broadcast && syncChannel) {
    syncChannel.postMessage({ type: 'CLEAR' })
  }
}

export function getImmediateLoadingAdminToken () {
  return sessionStorage.getItem(TOKEN_KEY) || ''
}

export function getImmediateLoadingAdmin () {
  const auth = storedAuth()
  return auth ? auth.admin : null
}

export function hasValidImmediateLoadingAdminSession () {
  const expiresAt = Number(sessionStorage.getItem(EXPIRES_AT_KEY) || 0)
  return Boolean(getImmediateLoadingAdminToken()) && expiresAt > Date.now() + 5000
}

export function requestImmediateLoadingAdminSession () {
  if (hasValidImmediateLoadingAdminSession()) {
    return Promise.resolve(true)
  }
  if (!syncChannel || typeof window === 'undefined') {
    return Promise.resolve(false)
  }
  return new Promise(resolve => {
    let finished = false
    const complete = value => {
      if (finished) {
        return
      }
      finished = true
      window.removeEventListener(SYNC_EVENT_NAME, handleSync)
      resolve(value)
    }
    const handleSync = () => complete(hasValidImmediateLoadingAdminSession())
    window.addEventListener(SYNC_EVENT_NAME, handleSync)
    syncChannel.postMessage({ type: 'REQUEST' })
    setTimeout(() => complete(hasValidImmediateLoadingAdminSession()), 250)
  })
}

export const IMMEDIATE_LOADING_ADMIN_SYNC_EVENT = SYNC_EVENT_NAME



// WEBPACK FOOTER //
// ./src/assets/utils/immediateLoadingAdminSession.js